class NisArticleReader {
  // private
  #defaultStorage = { articles: [] }
  #localStorageKey = 'nis-article-reader'

  // public
  _storage = null

  constructor(storage) {
    this._storage = storage
  }

  get storage() {
    let _localStorage = localStorage.getItem(this.#localStorageKey)

    if (!_localStorage) {
      _localStorage = JSON.stringify(this.#defaultStorage)
    }

    this._storage = JSON.parse(_localStorage)

    return this._storage
  }

  set storage(storage) {
    localStorage.setItem(this.#localStorageKey, JSON.stringify(storage))

    this._storage = this.storage
  }

  addReadArticle(id) {
    // If this is a non post object the fake id doesn't need to be stored
    if (id < 0) {
      return
    }

    this.storage = {
      articles: [...this.storage.articles, id.toString()]
    }
  }

  hasReadArticle(id) {
    return this.storage.articles.includes(id.toString())
  }
}

window.nisArticleReader = new NisArticleReader()

// ======= End class NextInSeries =======

let modalEl = document.querySelector('.nits__modal')
let modalItems = document.querySelectorAll('.nits__sidebar-list-item')
let modalCloseBtn = document.querySelector('.nits__modal-close')
let modalOpenBtn = document.querySelector(
  '.nits__breadcrumb .nis__modal-opener'
)

const setupNits = () => {
  if (modalOpenBtn) {
    modalOpenBtn?.addEventListener('click', () => {
      if (modalEl.style.visibility === 'visible') {
        modalEl.style.visibility = 'hidden'
        modalOpenBtn.classList.remove('opened')
      } else {
        modalEl.style.visibility = 'visible'
        modalOpenBtn.classList.add('opened')
      }
    })
  }
  if (modalCloseBtn) {
    modalCloseBtn.addEventListener('click', () => {
      modalEl.style.visibility = 'hidden'
      modalOpenBtn.classList.remove('opened')
    })
  }
  if (modalItems) {
    modalItems.forEach(item => {
      item.addEventListener('click', () => {
        onNitsModalClick(item)
      })
    })
  }
}

const onNitsModalClick = () => {
  setTimeout(() => {
    modalCloseBtn?.click()
  }, 300)
}

// eslint-disable-next-line no-unused-vars
let snapSlider = null

const setupNisSlider = () => {
  // eslint-disable-next-line no-undef
  snapSlider = new SnapSlider(document.querySelector('.nits__footer-body ul'), {
    id: 'bottom-slider',
    slides: document.querySelectorAll('.nits__footer-body ul li'),
    prev: document.querySelector('.nits__footer-body-prev-btn button'),
    next: document.querySelector('.nits__footer-body-next-btn button'),
    loop: false,
    on: {
      scroll: () => {
        document.querySelector('.nits__footer-body-prev-btn').style.display =
          snapSlider.current > 1 ? 'flex' : 'none'
      },
      load: initVisibleObservers
    }
  })
}

function initVisibleObservers() {
  const { container, slides } = snapSlider

  var observer = new IntersectionObserver(visibleCallback, {
    root: container,
    threshold: 0.9
  })

  // Watch all the slides.
  slides.forEach(slide => observer.observe(slide))
}

function visibleCallback(entries) {
  entries.forEach(updateVisibleClasses)
}

function updateVisibleClasses(entry) {
  const { slides } = snapSlider
  const slide = entry.target
  const index = slides.indexOf(slide) + 1

  if (entry.isIntersecting) {
    if (index === slides.length) {
      document.querySelector('.nits__footer-body-next-btn').style.display =
        'none'
    }
    slide.classList.add('is-visible')
  } else {
    if (index === slides.length) {
      document.querySelector('.nits__footer-body-next-btn').style.display =
        'flex'
    }
    slide.classList.remove('is-visible')
  }
}

/**
 * @description When used it keeps trying `maxTries` with a `delay` times 2 and tries `tryLogicCb` for a return of true to then call passed callback. If maxTries runs out, null is returned.
 * @param tryLogicCb {function<tryLogicCb>}
 * @param maxTries {number}
 * @param delay {number}
 * @param callback {function<callback>}
 * @returns Null|callback
 */
function exponentialBackoff(tryLogicCb, maxTries, delay, callback) {
  const result = tryLogicCb()

  if (result) {
    callback.call(this)
  } else {
    if (maxTries > 0) {
      setTimeout(() => {
        exponentialBackoff.call(
          this,
          tryLogicCb,
          --maxTries,
          delay * 2,
          callback
        )
      }, delay)
    }
  }
}

function isFooterContentReady() {
  return (
    Object.prototype.toString.call(document.querySelector('.nits__footer ')) !==
    '[object Undefined]'
  )
}

document.addEventListener(
  'DOMContentLoaded',
  exponentialBackoff.bind(this, isFooterContentReady, 10, 100, setupNisSlider)
)

document.addEventListener('DOMContentLoaded', setupNits)

const nisItem = function() {
  const nisItemVar = 'data-nis-item'
  const nisItems = document.querySelectorAll(`[${nisItemVar}]`) ?? []

  nisItems.forEach(item => {
    const markItemHasRead = element => {
      let elm = element.querySelector('a span.minute-to-read') ?? null
      if (!elm) return false
      elm.classList.remove('minute-to-read')
      elm.classList.add('previously-read')
      elm.innerHTML = 'previously read'

      let elmSpan = element.querySelector('a span.\\+fg-black') ?? null
      elmSpan.classList.remove('+fg-black')
      elmSpan.classList.add('+fg-gray-medium')
    }

    if (window.nisArticleReader.hasReadArticle(item.dataset.nisItem)) {
      markItemHasRead(item)
    }

    item.addEventListener('click', evt => {
      let clickedElement = null

      if (evt.target.dataset.hasOwnProperty('nisItem')) {
        clickedElement = evt.target
      } else {
        clickedElement = evt.target.closest(`[${nisItemVar}]`)
      }

      const nisSidebarItems =
        document.querySelectorAll(
          `.nits__sidebar-list-item[${nisItemVar}='${clickedElement.dataset.nisItem}']`
        ) ?? []

      window.nisArticleReader.addReadArticle(clickedElement.dataset.nisItem)

      nisSidebarItems.forEach(sidebar => {
        markItemHasRead(sidebar)
      })
    })
  })
}

const isNisReady = function() {
  return (
    Object.prototype.toString.call(document.querySelector('.nits__sidebar')) !==
      '[object Undefined]' ||
    Object.prototype.toString.call(document.querySelector('.nits__footer')) !==
      '[object Undefined]'
  )
}

document.addEventListener(
  'DOMContentLoaded',
  exponentialBackoff.bind(this, isNisReady, 10, 100, nisItem)
)
